<template>
  <div class="container">
    <div class="card-header mb2">
      <div class="suggestion-author-info">
        <div
          class="avatar-circle avatar-size ma1"
          :style="{
            backgroundImage: 'url(' + suggestion.author.avatar_url + ')',
            'background-size': 'cover',
            'background-position': 'center',
          }"
        ></div>
        <div class="suggestion-author-div ph2">
          <span class="suggestion-author b truncate-text">
            {{ suggestion.author.name }}
          </span>
          <span v-if="suggestion.author.job_title">
            {{ '(' + suggestion.author.job_title + ')' }}
          </span>

          <span class="suggestion-date i"> {{ suggestion_date }} </span>
        </div>
      </div>
      <div class="suggestion-options b" v-if="isParlayAdmin">
        <span class="suggestion-draft" v-if="suggestion.is_draft"> Draft </span>
        <div class="menu" style="width: 30px;">
          <pl-menu direction="right" :menuSize="3">
            <div slot="menu_trigger">
              <pl-button class="pl-icon pl-no-margin">
                <i class="fas fa-ellipsis-v" />
              </pl-button>
            </div>
            <ul menu-content>
              <!-- Submission Hiding and Reavealing -->
              <li @click="editSuggestion">
                <span> Edit </span>
              </li>
              <li @click="deleteSuggestion">
                <span>Delete</span>
              </li>
            </ul>
          </pl-menu>
        </div>
      </div>
      <div
        class="right suggestion-new"
        v-if="!isParlayAdmin && (isNewSuggestion || sugestionNotRead)"
      >
        <span class="green-new">
          New
        </span>
      </div>
    </div>

    <div class="card-suggestion-destination mt2 mb3" v-if="listOfNames !== ''">
      <div style="color: pl-secondary;">
        <span class="b"> Email sent to: </span>
        <span style="font-size: 14px;"> {{ listOfNames }} </span>
      </div>
    </div>
    <span style="font-size: 16px; color: #454444;" v-html="suggestion.content">
    </span>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  export default {
    data() {
      return {};
    },
    props: {
      suggestion: {
        type: Object,
        default: null,
      },
      isNewSuggestion: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters(['getProfile', 'getCurrentSchool']),
      suggestion_date() {
        if(this.suggestion.is_draft) {
          return moment(new Date(this.suggestion.updated_at)).format('MMMM Do YYYY h:mma');
        }
        return moment(new Date(this.suggestion.sent_at)).format('MMMM Do YYYY h:mma');
      },
      isParlayAdmin() {
        return this.getProfile.role === 'admin';
      },
      sentToNames() {
        if (this.suggestion.sent_to_emails.length)
          return this.suggestion.sent_to_emails.map((user) => user.name);
        return [];
      },
      listOfNames() {
        let names = '';
        if (this.sentToNames.length) {
          this.sentToNames.forEach((name) => {
            names += name + ',';
          });
        }
        return names.slice(0, -1);
      },
      sugestionNotRead() {
        var hasNew = false;
        if (this.getCurrentSchool.new_suggestions) {
          this.getCurrentSchool.new_suggestions.filter((s) => {
            if (s.id === this.suggestion.id) {
              hasNew = true;
            }
          });
        } else {
          hasNew = false;
        }
        return hasNew;
      },
    },
    methods: {
      editSuggestion() {
        EventBus.$emit('editSuggestion', this.suggestion);
      },
      deleteSuggestion() {
        EventBus.$emit('deleteSuggestion', this.suggestion.id);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl'

    .container{
        width:100%
        padding:20px
    }
    .suggestion-author{
        color:pl-secondary
        font-size:14px
    }
    .suggestion-date{
        font-size:10px
    }
    .suggestion-author-div{
      display: grid
    }
    .suggestion-edited-btn{
        color:pl-secondary !important
    }
    .card-suggestion-destination{
        color:pl-secondary !important
    }
    .avatar-size
        width: 30px
        height: 30px
        img
            height: 100%

    .suggestion-options{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: flex-end;
    }
    .card-header{
        display:flex
        max-height: 70px;
    }
    .suggestion-author-info
      width : 70%
      display : flex

    .suggestion-draft{
        color:pl-ruby
    }

    .suggestion-new{
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: flex-end;
    }

    .green-new
      border-radius: 5px
      background: #79ab62
      color: #fff
      font-size: 11px
      font-weight: 550
      padding: 2px 5px
</style>



// WEBPACK FOOTER //
// suggestionCard.vue?574d0a1a